import React, { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  TextField,
  InputLabel,
  OutlinedInput,
  MenuItem,
  Select,
} from "@mui/material";
import uploadImg from "../../../images/upload.svg";
import { StoreContext } from "../../../context/store";
import "./styles.css";
import { getParameterAPI } from "../../PolicyDetail/PolicyDetailService/policyDetailService";
import CryptoJS from 'crypto-js';

const BankInfomationForm = ({ channelType }) => {
  const {
    informationEditBank,
    updateInformationEditBank,
    informationEditPromptPayAccount,
    updateInformationEditPromptPay,
  } = useContext(StoreContext);

  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState('');
  const [age, setAge] = useState(localStorage.getItem("age"))
  const customerName = `${localStorage.getItem("first_name") || ""} ${
    localStorage.getItem("last_name") || ""
  }`;

  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };

  const username = decryptCardNumber(localStorage.getItem("customer_id"),process.env.REACT_APP_ENCRYPT_DATA)



  useEffect(() => {
    // console.log(age);
    // console.log(channelType);
    // console.log(
    //   "useContext Success informationEditBank : ",
    //   informationEditBank
    // );
    // console.log(
    //   "useContext Success informationEditPromptPayAccount : ",
    //   informationEditPromptPayAccount
    // );
    // console.log("Props : ", channelType);
    getBankName();
  }, [informationEditBank, channelType, informationEditPromptPayAccount]);

  const handleDataEdit = (key, value) => {
    let data = {
      [key]: value,
    };
    updateInformationEditBank(data);
  };

  const handleDataPromptPayEdit = (key, value) => {
    let data = {
      [key]: value,
    };
    updateInformationEditPromptPay(data);
  };

  const handleFileData = (key, value) => {
    let data = {
      [key]: value,
      bank_account_file_name: value[0].name,
    };
    updateInformationEditBank(data);
  };

  const getBankName = async () => {
    const result = await getParameterAPI(14);
    if (result.success) {
      const payload = result.payload;
      setBanks(result.payload);
      // console.log(payload);
    }
  };

  const handleBankChange = (event) => {
    updateInformationEditBank({bank_name: event.target.value})
    setSelectedBank(event.target.value);
  };
  

  let placeholderAcc;

  if (age < 7) {
    placeholderAcc = "ชื่อจริง - นามสกุล ผู้ปกครองโดยชอบธรรม";
  } else if (age >= 7 && age <= 19) {
    placeholderAcc = "ชื่อจริง - นามสกุล ผู้เอาประกันภัย หรือผู้ปกครองโดยชอบธรรม";
  } else if (age >= 20) {
    placeholderAcc = "ชื่อจริง - นามสกุล ผู้เอาประกันภัย";
  } else {
    placeholder
  }


  

  return (
    <>
      {channelType === "bank" ? (
        <>
          <InputLabel
            htmlFor="bank_account_name"
            className="label"
            style={{ fontWeight: "bold" }}
          >
            ชื่อบัญชี<span className="text-danger mx-1">*</span>
          </InputLabel>
          <TextField
            InputProps={{ sx: { borderRadius: 16 } }}
            id="bank_account_name"
            type="search"
            className="mb-2 label"
            placeholder="ชื่อจริง - นามสกุล"
            variant="outlined"
            value={informationEditBank.bank_account_name}
            size="small"
            onChange={(e) =>
              handleDataEdit("bank_account_name", e.target.value)
            }
            fullWidth
          />
          <InputLabel
            htmlFor="bank_name"
            className="label"
            style={{ fontWeight: "bold" }}
          >
            ธนาคาร<span className="text-danger mx-1">*</span>
          </InputLabel>
          <Select
            input={<OutlinedInput />}
            style={{ borderRadius: "16px", height: "42px" }}
            id="bank_name"
            variant="outlined"
            fullWidth
            displayEmpty
            className="select-input mb-2 label"
            // value={selectedBank}
            value={informationEditBank.bank_name}
            onChange={handleBankChange}
          >
            <MenuItem value="" disabled>
              เลือกธนาคาร
            </MenuItem>
            {banks.map((bank) => (
              <MenuItem key={bank.pmdId} value={bank.name}>
                {bank.name}
              </MenuItem>
            ))}
            {/* <MenuItem value="อื่นๆ">อื่นๆ</MenuItem> */}
          </Select>
          <InputLabel
            htmlFor="bank_account"
            className="label"
            style={{ fontWeight: "bold" }}
          >
            เลขที่บัญชี<span className="text-danger mx-1">*</span>
          </InputLabel>
          <TextField
            InputProps={{ sx: { borderRadius: 16 } }}
            id="bank_account"
            type="search"
            className="mb-2 label"
            placeholder="เลขที่บัญชี"
            variant="outlined"
            value={informationEditBank.bank_account}
            
            onChange={(e) => {
              const value = e.target.value;
              // กรองให้กรอกได้เฉพาะตัวเลขและจำกัดให้ไม่เกิน 13 ตัวอักษร
              if (/^\d{0,25}$/.test(value)) {
                handleDataEdit("bank_account", value);
              }
            }}
            size="small"
            fullWidth
          />
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          
          <InputLabel
            className="label"
            htmlFor="bank_account_file"
            style={{
              fontWeight: "bold",
              display: "ruby",
              flexDirection: "row",
              whiteSpace: "normal",
              wordWrap: "break-word",
            }}
            // fullWidth
          >
            {age < 7 ? (
              <>
                สำเนาสมุดบัญชีผู้ปกครองโดยชอบธรรม หรือ ผู้รับโอนสิทธิ <p className="text-danger mx-1">*</p>
              </>
            ) : age >= 7 && age <= 19 ? (
              <>
                สำเนาสมุดบัญชีผู้เอาประกันภัย หรือ ผู้ปกครองโดยชอบธรรม หรือผู้รับโอนสิทธิ <p className="text-danger mx-1">*</p>
              </>
            ) : age >= 20 ? (
              <>
                สำเนาสมุดบัญชีผู้เอาประกันภัย หรือ ผู้รับโอนสิทธิ <p className="text-danger mx-1">*</p>
              </>
            ) : (
              <>
                สำเนาสมุดบัญชีเงินฝากธนาคาร <p className="text-danger mx-1">*</p>
              </>
            )}
          </InputLabel>
          <label
            htmlFor="file1"
            className="btn-upload-file d-flex flex-row justify-content-center align-items-center"
            style={{ marginTop: "-25px" }} 
          >
            <i className="fa fa-cloud-upload"></i> อัพโหลด
            <img
              className="icon-image-content-upload"
              src={uploadImg}
              style={{ textAlign: "center" }}
              alt=""
            />
          </label>
          

          <input
            type="file"
            id="file1"
            accept="image/png, image/jpeg, image/jpg, application/pdf"
            style={{ display: "none" }}
            onChange={(e) => {
              handleFileData("bank_account_file", e.target.files);
            }}
          />
        </div>
        

        {informationEditBank.bank_account_file_name && (
          <p className="ml-2 text-danger label">
            {informationEditBank.bank_account_file_name || ""}
          </p>
        )}
        <div style={{ color: "red", marginTop: "5px", fontSize: "14px" }}>
            * ยกเว้นธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธ.ก.ส.) และ ธนาคารเกียรตินาคิน 
        </div>
        </>
      ) : (
        <>
          <InputLabel
            htmlFor="prompt_pay_account_name"
            className="label"
            style={{ fontWeight: "bold" }}
          >
            ชื่อบัญชี<span className="text-danger mx-1">*</span>
          </InputLabel>
          <TextField
            InputProps={{ sx: { borderRadius: 16 } }}
            id="prompt_pay_account_name"
            type="search"
            className="mb-2 label"
            placeholder={placeholderAcc}  // Set placeholder here directly
            inputProps={{
              style: { fontSize: "16px" }, // Normal font size for input text
            }}
            sx={{
              "& ::placeholder": {
                fontSize: "16px", // Default placeholder font size for large screens
                "@media (max-width:600px)": {
                  fontSize: "11px", // Smaller placeholder font size for smaller screens
                },
              },
            }}

            variant="outlined"
            value={informationEditPromptPayAccount.prompt_pay_account_name || customerName}
            size="small"
            onChange={(e) =>
              handleDataPromptPayEdit("prompt_pay_account_name", e.target.value) || customerName
            }
            fullWidth
          />
          <InputLabel
            htmlFor="prompt_pay_account"
            className="label"
            style={{ fontWeight: "bold" }}
          >
            เลขประจำตัวประชาชน<span className="text-danger mx-1">*</span>
          </InputLabel>
          <TextField
          InputProps={{ sx: { borderRadius: 16 } }}
          id="prompt_pay_account"
          type="search"
          className="mb-2 label"
          placeholder="เลขประจำตัวประชาชน 13 หลัก"
          variant="outlined"
          value={informationEditPromptPayAccount.prompt_pay_account || username}
          onChange={(e) => {
            const value = e.target.value;
            // กรองให้กรอกได้เฉพาะตัวเลขและจำกัดให้ไม่เกิน 13 ตัวอักษร
            if (/^\d{0,13}$/.test(value)) {
              handleDataPromptPayEdit("prompt_pay_account", value) || username
            }
          }}
          // inputProps={{ maxLength: 13 }}
          inputProps={{
            style: { fontSize: "16px" }, // Normal font size for input text
          }}
          sx={{
            "& ::placeholder": {
              fontSize: "16px", // Default placeholder font size for large screens
              "@media (max-width:600px)": {
                fontSize: "11px", // Smaller placeholder font size for smaller screens
              },
            },
          }}
          size="small"
          fullWidth
        />
        </>
      )}
    </>
  );
};

export default BankInfomationForm;
